export var rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function')
    ? Symbol.for('rxSubscriber')
    : '@@rxSubscriber';
export var $$rxSubscriber = rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map